// extracted by mini-css-extract-plugin
module.exports = {"ErrorPage":"ErrorPage_ErrorPage__3OKUW","ErrorPage__text":"ErrorPage_ErrorPage__text__2LBr2","ErrorPage__backLink":"ErrorPage_ErrorPage__backLink__2MAwv"};